import type { TreeTableDesignTokens } from '@primeuix/themes/types/treetable'

export default {
  row: {
    color: '{content.color}',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    background: '{content.background}',
    hoverColor: '{sr.hover.color}',
    selectedColor: '{highlight.color}',
    hoverBackground: '{content.hover.background}',
    selectedBackground: '{highlight.background}',
  },
  root: {
    transitionDuration: '{transition.duration}',
  },
  footer: {
    padding: '0.75rem 1rem',
    borderColor: '{treetable.border.color}',
    borderWidth: '0 0 1px 0',
  },
  header: {
    padding: '0.75rem 1rem',
    borderColor: '{treetable.border.color}',
    borderWidth: '1px 0 1px 0',
  },
  bodyCell: {
    gap: '0.5rem',
    padding: '0.75rem 1rem',
    borderColor: '{treetable.border.color}',
  },
  sortIcon: {
    size: '0.875rem',
    color: '{text.muted.color}',
    hoverColor: '{text.hover.muted.color}',
  },
  footerCell: {
    padding: '0.75rem 1rem',
    borderColor: '{treetable.border.color}',
  },
  headerCell: {
    gap: '0.5rem',
    padding: '0.75rem 1rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    hoverColor: '{content.hover.color}',
    borderColor: '{treetable.border.color}',
    selectedColor: '{highlight.color}',
    selectedBackground: '{highlight.background}',
  },
  colorScheme: {
    dark: {
      root: {
        borderColor: '{surface.800}',
      },
      footer: {
        color: '{text.color}',
        background: '{surface.800}',
      },
      header: {
        color: '{text.color}',
        background: '{surface.800}',
      },
      bodyCell: {
        selectedBorderColor: '{primary.900}',
      },
      footerCell: {
        color: '{text.color}',
        background: '{surface.800}',
      },
      headerCell: {
        color: '{text.color}',
        background: '{surface.800}',
        hoverBackground: '{surface.700}',
      },
    },
    light: {
      root: {
        borderColor: '{content.border.color}',
      },
      footer: {
        color: '{text.color}',
        background: '{surface.50}',
      },
      header: {
        color: '{text.color}',
        background: '{surface.50}',
      },
      bodyCell: {
        selectedBorderColor: '{primary.100}',
      },
      footerCell: {
        color: '{text.color}',
        background: '{surface.50}',
      },
      headerCell: {
        color: '{text.color}',
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
      },
    },
  },
  columnTitle: {
    fontWeight: '700',
  },
  loadingIcon: {
    size: '2rem',
  },
  columnFooter: {
    fontWeight: '700',
  },
  paginatorTop: {
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
  },
  columnResizer: {
    width: '0.5rem',
  },
  paginatorBottom: {
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
  },
  resizeIndicator: {
    color: '{primary.color}',
    width: '1px',
  },
  nodeToggleButton: {
    size: '1.75rem',
    color: '{text.muted.color}',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    hoverColor: '{text.color}',
    borderRadius: '50%',
    hoverBackground: '{content.hover.background}',
    selectedHoverColor: '{primary.color}',
    selectedHoverBackground: '{content.background}',
  },
} satisfies TreeTableDesignTokens
